// Porównywanie tekstu w wyszukiwarkach v2. Nikt nie pisze „miód" z kreską,
// gdy szuka miodu — więc do dopasowania zdejmujemy znaki diakrytyczne
// i wielkość liter. Do wyświetlania zostaje oryginał. „ł" nie rozkłada się
// w NFD (to osobna litera, nie „l" z kreską), więc zamieniamy je ręcznie.
export const norm = (value) => (value ?? '')
    .toString()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/ł/g, 'l')
    .trim();

// Czy `haystack` zawiera `needle` po zdjęciu ogonków.
export const looseIncludes = (haystack, needle) => norm(haystack).includes(norm(needle));

// Polska liczba mnoga ma trzy formy: 1 rata, 2–4 raty, 5+ rat
// (z wyjątkiem nastek: 12–14 rat).
export const plural = (n, one, few, many) => {
    if (n === 1) return one;
    const ones = n % 10;
    const teens = n % 100;
    return ones >= 2 && ones <= 4 && !(teens >= 12 && teens <= 14) ? few : many;
};
